<template>
<div>
	<MainNavBar />
	<Hero :hero="heroProperty" />
	<section-search />
	<CallToAction :content="propertyCTA" />
	<GmxFooter />
</div>
</template>

<script>
import MainNavBar from '@/components/main-nav-bar.vue';
import Hero from '@/components/hero.vue';
import Section from '@/components/section.vue';
import SectionSearch from '@/components/section-search.vue';
import CallToAction from '@/components/call-to-action.vue';
import GmxFooter from '@/components/footer.vue';
import * as log from 'loglevel';
export default {
	name: "Property",
	components: {
		MainNavBar,
		Hero,
		Section,
    SectionSearch,
		CallToAction,
		GmxFooter,
	},
	data() {
		return {
      heroProperty: { 
        eyebrowIcon: 'trinity_properties_hat.png',
        eyebrowTitle: 'Property Management',
        eyebrowSubtitle: 'A single source for document management and control',
        header: 'Property Management',
        subheader: 'Each stakeholder collaborates on TrinPods, representing Units and Buildings, and to change projects on Project TrinPods.',
        img: 'hero-intelligentPDF.png',
        videoId: '683264838',
        buttons: [
          /*{ label: 'Property', path: '', id: 'property' },
          { label: 'Documents', path: '', id: 'documents' },
          { label: 'IntelligentPDF\u2122', path: '', id: 'intelligent-pdf' },
          { label: 'TrinPod\u2122', path: '', id: 'trinpod' },*/
        ]
      },
			/*property: { 
        header: 'TrinApp\u2122 Property (coming soon)',
        headerIcon: '',
        id: 'property',
        listOneTitle: 'What it does for you',
        listOneBullets: [
          { text: 'Collaborate and manage properties in decentralized, Solid compliant storage.' },
          { text: 'Search across hundreds of properties and projects each containing thousands of documents.' }
        ],
        listTwoTitle: 'What it does better',
        listTwoBullets: [
          { text: 'Find the information you need to take action in seconds.' },
          { text: 'State-of-the-art Security.' },
          { text: 'High Performance with any number of properties and projects, each with any number of documents and any amount of data.' },
          { text: '100% ownership and control of your data.' },
          { text: 'Detailed access control, version control, history.' },
          { text: 'Your property information is free from apps that create silos. Share the data with any Solid compliant app.' },
        ],
        image: 'project-pods.png',
        colOrderText: 2,
        colOrderImage: 1,
        bgClass: 'bg-neon-blue-grad'
      },*/
			propertyCTA: {
        header: 'For more information',
        bgClass: 'bg-neon-blue-grad',
        btnText: 'Contact us',
        btnVariant: 'turquoise'
      }
		}
	},
	methods: {
		img: function (image) {
			require(image)
		}
	}
}
</script>

<style>
.container-bg-property {
    background-image: url("../assets/property_image.jpg");
    background-repeat: no-repeat;
    background-size: cover;
    background-position: 0 0px;
    height: 480px;
}
</style>
